import { apiClient } from "helpers/api_helper";

export const generateStoreToMayaveInvoice = async (voucherNo: string) => {
    try {
        const response = await apiClient.get(`/api/v1/ReturnToMayave/GenerateStoreToMayaveInvoice?voucherNo=${voucherNo}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

// list 
export const getAllReturnToMayaveProduct = async (searchText: string, statusId: number,) => {
    try {
        const response = await apiClient.get(`/api/v1/ReturnToMayave/GetAllReturnToMayaveProducts?searchText=${searchText}&statusId=${statusId}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const generateMayaveToStoreInvoice = async (voucherNo: string) => {
    try {
        const response = await apiClient.get(`/api/v1/ReturnToMayave/GenerateMayaveToStoreInvoice?voucherNo=${voucherNo}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const updateReturnToMayaveProductPricesBy = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/ReturnToMayave/UpdateReturnToMayaveProductPricesByMayave', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

// view by id
export const getReturnToMayaveProductSummariesByVoucher = async (voucherNo: string) => {
    try {
        const response = await apiClient.get(`/api/v1/ReturnToMayave/GetReturnToMayaveProductSummariesByVoucherNo?voucherNo=${voucherNo}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const updateReturnToMayaveProduct = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/ReturnToMayave/UpdateReturnToMayaveProductPricesAccept', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const GenerateStoreToMayaveAcceptInvoice = async (voucherNo: string) => {
    try {
        const response = await apiClient.get(`/api/v1/ReturnToMayave/GenerateStoreToMayaveAcceptInvoice?voucherNo=${voucherNo}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};